// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__rDZOe","inputWrap":"Table_inputWrap__3Fj86","col":"Table_col__3JUgS","bmiTooltip":"Table_bmiTooltip__1ugWc"};